import request from '@/utils/request'


// 查询优惠券列表
export function listCoupon(query) {
  return request({
    url: '/biz/admin/activity/coupon/platform/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询优惠券分页
export function pageCoupon(query) {
  return request({
    url: '/biz/admin/activity/coupon/platform/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询优惠券列表
export function listMerchantCoupon(query) {
  return request({
    url: '/biz/admin/activity/coupon/merchant/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}


// 查询优惠券分页
export function pageMerchantCoupon(query) {
  return request({
    url: '/biz/admin/activity/coupon/merchant/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询优惠券详细
export function getCoupon(data) {
  return request({
    url: '/biz/admin/activity/coupon/detail',
    method: 'get',
    params: data
  })
}

// 新增优惠券
export function addCoupon(data) {
  return request({
    url: '/biz/admin/activity/coupon/add',
    method: 'post',
    data: data
  })
}

// 修改优惠券
export function updateCoupon(data) {
  return request({
    url: '/biz/admin/activity/coupon/edit',
    method: 'post',
    data: data
  })
}

export function sendCoupon(data) {
  return request({
    url: '/biz/admin/activity/coupon/send',
    method: 'post',
    data: data
  })
}

// 删除优惠券
export function delCoupon(data) {
  return request({
    url: '/biz/admin/activity/coupon/delete',
    method: 'post',
    data: data
  })
}
